const en =  {
  locales: ["en"],
  messages: {
    allRightsReserved: "All Rights Reserved",
    "heading.events": "Events",
    "heading.rooms": "Rooms",
    "heading.speakers": "Speakers",
    "heading.presentations": "presentations",
    "heading.accountInfo": "Account Information",
    "heading.login": "LOGIN",
    "heading.signup": "SIGN UP",
    "heading.persinalinfo": "PERSONAL INFORMATION",
    "heading.addEvent": "ADD EVENT",
    "heading.transactions": "Transactions",
    "heading.transactions.intro": "A list of recent transactions is shown here, queried from the PG API",
    "heading.managing": "Managing",
    "heading.eventVideos": "Videos from the event",
    "heading.allVideos": "All Videos from ",
    "button.login": "Login",
    "button.signup": "Sign up",
    "button.back": "BACK",
    "button.createEvent": "CREATE EVENT",
    "button.editEvent": "EDIT EVENT",
    "button.uploadingLogo": "Uploading Logo",
    "button.createRoom": "CREATE CONFERENCE ROOM",
    "button.editRoom": "EDIT CONFERENCE ROOM",
    "button.saveRoom": "SAVE CONFERENCE ROOM",
    "button.createSpeaker": "CREATE SPEAKER",
    "button.create": "CREATE",
    "button.editSpeaker": "EDIT SPEAKER",
    "button.saveSpeaker": "SAVE SPEAKER",
    "button.uploadingPhoto": "Uploading Photo",
    "button.createPresentation": "CREATE PRESENTATION",
    "button.editPresentation": "EDIT PRESENTATION",
    "button.savePresentation": "SAVE PRESENTATION",
    "button.uploadingPresentation": "Uploading Presentation",
    "button.events.all": "All Events",
    "button.addPayment": "Add Payment Method",
    "button.changePayment": "Change Payment Method",
    "error.input-username": "Invalid Username",
    "link.view": "View",
    "link.home": "Home",
    "link.support": "Support",
    "link.dashboard": "Dashboard",
    "link.account": "Account",
    "link.features": "Features",
    "link.pricing": "Pricing",
    "link.about": "About",
    "link.login": "Login",
    "link.register": "Register",
    "link.logout": "Logout",
    "link.download": "Download",
    "link.room-software": "Room Software",
    "label.uploadLogo": "Upload Logo (Max: 200 KB)",
    "label.logoUploaded": "Logo Uploaded",
    "label.actions": "Actions",
    "label.room.isLoggedIn": "Logged In?",
    "label.noPayment": "Your account has not been set up with a payment source yet",
    "label.noAddress": "Please update your account with a billing address",
    "select.displayMode.public": "Public",
    "select.displayMode.password": "Password Protected",
    "select.displayMode.link": "Anyone with link",
    "select.theme.orange": "Orange",
    "select.theme.grey": "Grey",
    "select.theme.black": "Black",
    "error.emailinvalid": "This is not a valid email",
    "error.alphanumeric": "Only alphabets and numbers allowed",
    "error.atleast6": "Enter atleast 6 characters",
    "error.passnomatch": "Passwords don't match",
    "action.heading": "Confirm Action!",
    "action.pre": "Are you sure you want to",
    "action.confirm": "Confirm",
    "action.cancel": "Cancel",
    "action.delete-event": "delete the event",
    "action.clone-event": "clone the event",
    "action.delete-room": "delete the room",
    "action.delete-speaker": "delete the speaker",
    "input.email": "Email",
    "input.password": "Password",
    "input.password.confirm": "Confirm Password",
    "input.title": "Title",
    "input.name": "Name",
    "input.firstname": "First name",
    "input.lastname": "Last name",
    "input.phone": "Phone",
    "input.mobile": "Mobile",
    "input.address": "Address",
    "input.zipcode": "Zipcode",
    "input.city": "City",
    "input.country": "Country",
    "input.agreeTerms": "I agree with the Terms of use",
    "input.companyname": "Company Name",
    "input.event.name": "Event Name",
    "input.event.dates": "Dates",
    "input.event.start": "Start Date",
    "input.event.end": "End Date",
    "input.event.end.error.notBeforeStart": "Cannot be before start date",
    "input.event.venue": "Venue Name",
    "input.event.address": "Venue Address",
    "input.event.website": "Website",
    "input.event.displayMode": "Display Mode",
    "input.event.displayPassword": "Display Password",
    "input.event.logo": "Upload Logo (Max: 200 KB)",
    "input.event.uploadByDate": "Upload By Date",
    "input.event.uploadByDate.error.notAfterStart": "Cannot be after end date",
    "input.event.web_ad": "Web Advertisement",
    "input.event.theme": "Theme",
    "input.event.agreementMandatory": "Agreement Mandatory for Speakers?",
    "input.room.name": "Room Name",
    "input.room.login": "Room Login",
    "input.room.password": "Password",
    "input.room.password.confirm": "Confirm Password",
    "input.room.ad": "Room Advertisement",
    "input.speaker.name": "Speaker Name",
    "input.speaker.photo": "Speaker Photo",
    "input.speaker.photoUpload": "Upload Photo (Max: 200 KB)",
    "input.speaker.photoUploaded": "Photo Uploaded",
    "input.speaker.description": "Description",
    "input.presentation.name": "Presentation Name",
    "input.presentation.date": "Date",
    "input.presentation.time": "Start Time",
    "input.presentation.start.time": "Start Time",
    "input.presentation.room": "Conference Room",
    "input.presentation.speaker": "Speaker",
    "input.presentation.information": "Information",
    "input.presentation.presentationFile": "Presentation File",
    "input.presentation.presentationUpload": "Upload Presentation",
    "input.presentation.presentationUploaded": "Presentation Uploaded",
    "input.presentation.datetime": "Date & Time",
    "input.presentation.status": "Status",
    "input.presentation.isPublic": "Public?",
    "button.presentation-download-latest": "Download Recent Presentation File",
    "alert.presentation-not-uploaded": "No presentation file uploaded",
    "button.presentation-manage-files": "Manage Presentation files",
    "button.presentation-edit-info": "Edit Presentation",
    "button.presentation-delete": "Delete Presentation",
    "button.presentation-delete-file": "Delete Presentation File",
    "heading.files-uploaded-for": "files uploaded for",
    "label.file-uploaded-on": "File uploaded on",
    "link.profile-update": "Update Profile",
    "button.changePassword": "Change Password",
    "link.contact": "Contact",
    "input.contact.name": "Name",
    "input.contact.email": "Email",
    "input.contact.message": "Message",
    "button.presentations-all-download": "Download all Presentations",
    "label.presentations-all-download": "This will download the latest presentation files, if available, for each of the presentations in this event",
    "label.allow-popups-multiple-downloads": "Please allow popups and enable multiple downloads from e-slides.net if prompted",
    "input.event.set-password": "Enter a password",
    "error.invalid-event-password": "Entered Event Password was Invalid",
    "error.enter-event-password": "Enter Event Password",
    "button.event-view": "View Event",
    "label.agreement-mandatory-message": "This is displayed when the agreement is mandatory. Please provide text",
    "error.last-date-over": "The last date to upload presentations for this event is over",
    "label.no-presentations-for-upload": "No presentations have been assigned for you to upload files. Possibly the presentation was edited/deleted or has been recorded",
    "button.send-email": "Email Speakers",
    "error.file-upload": "Error while uploading File",
    "contact.submit-success": "Contact form submitted successfully",
    "error.captcha-error": "Captcha error. Please retry",
    "error.mongo-error": "Database error. Please retry",
    "error.prompt-password": "Please enter password",
    "error.invalid-password": "Invalid Password",
    "event.fetch-success": "Event fetched successfully",
    "error.date-over": "Last date for submission of presentation is over",
    "event.clone-success": "Event cloned successfully",
    "event.create-success": "Event created successfully",
    "event.update-success": "Event updated successfully",
    "event.delete-success": "Event deleted successfully",
    "events.fetch-success": "Events fetched successfully",
    "email.success": "Email sent",
    "error.[UPLOAD_URL]-missing": "[UPLOAD_URL] in required in Email Text",
    "event.creating": "Creating Event",
    "presentation.create-success": "Presentation created successfully",
    "presentation.update-success": "Presentation updated successfully",
    "presentation.delete-success": "Presentation deleted successfully",
    "presentation.fetch-success": "Presentation fetched successfully",
    "presentations.fetch-success": "Presentations fetched successfully",
    "presentation.token-success": "Presentation Video Token generated successfully",
    "error.video-server": "Video Server Error",
    "presentation.creating": "Creating Presentation",
    "room.create-success": "Room created successfully",
    "room.update-success": "Room updated successfully",
    "room.delete-success": "Room deleted successfully",
    "room.fetch-success": "Room fetched successfully",
    "rooms.fetch-success": "Rooms fetched successfully",
    "error.duplicate-roomlogin": "Room login exists. Please use a different login",
    "room.login-success": "Room logged in successfully",
    "room.logout-success": "Room logged out successfully",
    "room.error-invalid-credentials": "Invalid Room Credentials",
    "error.invalid-room-token": "Invalid Room Token",
    "success.authenticated": "Authenticated",
    "room.creating": "Creating your Conference Room",
    "error.s3-error": "Error connecting to File Server",
    "error.presentation-not-found": "Presentation Not Found",
    "speaker.create-success": "Speaker created successfully",
    "speaker.update-success": "Speaker updated successfully",
    "speaker.delete-success": "Speaker deleted successfully",
    "speaker.fetch-success": "Speaker fetched successfully",
    "speakers.fetch-success": "Speakers fetched successfully",
    "speaker.creating": "Creating your Speaker",
    "user.create-success": "Profile created successfully",
    "user.update-success": "Profile updated successfully",
    "user.fetch-success": "User fetched successfully",
    "user.creating": "Creating your Account",
    "user.updating": "Updating your Account",
    "user.authenticating": "Authenticating",
    "user.stripe-success": "You payment details has been set up successfully. You may now visit the Dashboard to manage the events.",
    "error.server-error": "There was an error",
    "error.invalid-username": "Invalid username",
    "user.login-success": "Logged in successfully",
    "error.invalid-token": "Invalid Token. Session possibly expired",
    "error.duplicate-email": "Email is taken. Please use a differnet email",
    "error.stripe-error": "Error connecting to Payment Gateway",
    "success.subscription-updated": "Subscription Updated",
    "heading.send-email": "Send Email to Speakers for Presentation File Upload",
    "form.speakers": "Speakers",
    "form.cc": "CC",
    "form.bcc": "BCC",
    "form.email-subject": "Email Subject",
    "form.email-default-subject": "Upload presentation for",
    "heading.substitutions": "Substitutions in Email Content",
    "sub.speaker_name": "Speaker Name.",
    "sub.upload_url": "URL for the speaker to upload the file.",
    "sub.video_upload_url": "URL for the speaker to upload the video.",
    "sub.photo_upload_url": "URL for the speaker to upload their photo.",
    "sub.video_watch_url": "URL for the speaker to watch the video.",
    "sub.due_date": "Presentation upload on or before date.",
    "form.email-default-message": "[EVENT_LOGO]<br /><br />Dear [SPEAKER_NAME],<br /><br />Upload your presentation file(s) at [UPLOAD_URL] by [UPLOAD_BY_DATE].<br /><br />Thank you.",
    "form.email-virtual-message": `[EVENT_LOGO]<br /><br />Cher [SPEAKER_NAME],<br /><br />Afin d’enregistrer votre présentation pour cet évènement, nous vous remercions de télécharger le logiciel e-slides en cliquant ici :  [SOFTWARE_LINK]<br /><br />Une fois téléchargé et installé merci de choisir "accès intervenant"<br/>&nbsp;&nbsp;&nbsp;Identifiant de l'évènement : [EVENT_SLUG]<br />&nbsp;&nbsp;&nbsp;Mail de l'intervenant : [SPEAKER_LOGIN]<br/>&nbsp;&nbsp;&nbsp;Mot de passe de l'intervenant : [SPEAKER_PASSWORD]<br/><br/>Une fois connecté, vous devez choisir votre micro, l'écran à enregistrer (bien choisir l'écran ou sera affiché le diaporama du PPT en cas de bureau étendu) et votre webcam.<br/><br/>Ensuite vous enregistrer et choisissez la présentation à enregistrer. Vous enregistrez votre présentation avec le son comme si vous êtiez dans une salle de conférence.<br/><br/>A la fin de l'enregistrement vous pouvez enregistrer une autre présentation ou aller dans l'onglet transfert pour vérifier puis envoyer.<br/><br/>Bien cordialement,<br/><br/>L'équipe d'organisation`,
    "form.email-virtual-subject": 'Enregistrez votre présentation',
    "form.placeholder-missing": "[UPLOAD_URL] missing in email content.",
    "form.send-email": "Send EMail",
    "heading.noEventVideos": "No publicly viewable videos yet",
    "user.logout-success": "Logged out successfully",
    "heading.upload-ppt": "Upload files for your presentations below.",
    "heading.upload-video": "Upload videos for your presentations below.",
    "sub.event_logo": "Event Logo",
    "input.room.login-short": "Room Login",
    "filter.byRoom": "Filter by Conference Room",
    "filter.byTitle": "Filter Presentations by Title",
    "filter.remove": "Remove filter",
    "heading.last-30-days-usage": "Usage for the last 30 days",
    /* TODO */
    "label.agree-broadcast": "I agree that my presentation will be broadcast after the event",
    /* TODO */
    "button.saveEvent": "SAVE EVENT",
    "action.delete-presentation-file": "delete the presentation file",
    /* TODO */
    "label.ppt": "PPT",
    /* TODO */
    "alert.not-recorded-yet": "Presentation has not been recorded yet",
    /* TODO */
    "ppt-status.no-ppt": "No Presentation File",
    "ppt-status.ppt-uploaded": "Presentation Uploaded",
    "ppt-status.recording": "Recording Video",
    "ppt-status.video-recorded": "Video Recorded",
    "ppt-status.published": "Published",
    "form.email-save": "Save Content",
    "form.email-load-saved": "Load Saved Content",
    "form.email-load-default": "Load Default Content",
    "heading.form.basic_information": "Basic Information",
    "heading.form.venue_information": "Venue Information",
    "heading.form.room_information": "Room Information",
    "heading.form.website_information": "Website Information",
    "heading.form.engagement_information": "Participation Engagement Information",
    "input.event.forum": "Forum",
    "input.event.quiz": "Quiz",
    "input.event.moderator_site": "Moderator Site",
    "input.event.moderator_site_password": "Moderator Site Password",
    "input.event.audience_site": "Enable Event Site",
    "event.form.price-quiz": "2 credits",
    "event.form.price-forum": "1 credit",
    "event.form.price-moderator": "Free",
    "label.status.uploadedPresentations": "Uploaded Presentations",
    "label.status.recordedVideos": "Recorded Videos",
    "label.status.uploadedVideos": "Uploaded Videos",
    "button.openModeratorSite": "Open Moderator Site",
    "button.openAudienceSite": "Open Event Site",
    "error.network-error": "There was a network error. Please retry.",
    "error.token-sent-wait-1-hour": "Token already sent. Please request after one hour of previous request.",
    "forgot-password.email-sent": "Please click on the link sent to your email to set new password.",
    "forgot-password.reset-success": "Password has been reset successfully. Pleae login.",
    "forgot-password.invalid-token": "Reset token invalid or expired. Please request new link to reset password.",
    "error.fileTooBig": "The file size is too big. Maximum file size allowed: 200 KB.",
    "error.fileTooBig100": "The file size is too big. Maximum file size allowed: 100 KB.",
    "heading.schedule-data": "Schedule Data",
    "tab.schedule-colors": "Themes",
    "tab.schedule-types": "Types",
    "tab.schedule-associations": "Associations",
    "tab.schedule-sessions": "Sessions",
    "button.s.color-create": "Add Theme",
    "button.s.type-create": "Add Type",
    "button.s.association-create": "Add Association",
    "button.s.session-create": "Add Session",
    "button.s.color-update": "Edit Theme",
    "button.s.type-update": "Edit Type",
    "button.s.session-update": "Edit Session",
    "button.s.association-update": "Edit Association",
    "confirm.s.color-delete": "Are you sure you want to delete the theme?",
    "confirm.s.type-delete": "Are you sure you want to delete the Type?",
    "confirm.s.association-delete": "Are you sure you want to delete the Association?",
    "confirm.s.session-delete": "Are you sure you want to delete the Session?",
    "alert.s.color.create_do": "Creating Theme",
    "alert.s.type.create_do": "Creating Type",
    "alert.s.association.create_do": "Creating Association",
    "alert.s.session.create_do": "Creating Session",
    "color.create-success": "Theme Created",
    "type.create-success": "Type Created",
    "association.create-success": "Association Created",
    "session.create-success": "Session Created",
    "alert.s.color.update_do": "Updating Theme",
    "alert.s.type.update_do": "Updating Type",
    "alert.s.association.update_do": "Updating Association",
    "alert.s.session.update_do": "Updating Session",
    "color.update-success": "Theme Updated",
    "type.update-success": "Type Updated",
    "association.update-success": "Association Updated",
    "session.update-success": "Session Updated",
    "color.delete-success": "Theme Deleted",
    "type.delete-success": "Type Deleted",
    "association.delete-success": "Association Deleted",
    "session.delete-success": "Session Deleted",
    "edit": "Edit",
    "delete": "Delete",
    "button.uploadFile": "Upload File",
    "input.presentation.end_time": "End Time",
    "input.end_time.error.notBeforeStartTime": "End time cannot be before Start time",
    "input.presentation.color": "Schedule Theme",
    "input.presentation.type": "Schedule Type",
    "input.presentation.association": "Schedule Association",
    "input.presentation.session": "Schedule Session",
    "input.login": "Login",
    "input.event.slug": "URL Slug",
    "error.slug-taken": "Slug not available",
    "form.toggle-speakers": "Toggle speakers",
    "heading.send-moderator-email": "Send Moderator Email",
    "form.select-speakers-without-ppt": "Speakers without PPT",
    "button.send-moderator-email": "Email Moderators",
    "form.moderator-email-default-subject": "Invitation to moderate event:",
    "form.moderator-site-missing": "Moderator URL missing",
    "form.moderator-password-missing": "Moderator Password missing",
    "form.moderator-email-default-message": "[EVENT_LOGO]<br /><br />Dear Moderator,<br /><br />You can manage the event at [MODERATOR_SITE_URL] using the password [MODERATOR_SITE_PASSWORD].<br /><br />Thank you.",
    "sub.moderator_site": "Moderator Site URL",
    "sub.moderator_password": "Moderator Site password",
    "form.select-rooms": "Select rooms for this event",
    "error.not-enough-credits": "You do not have enough credits",
    "heading.purchase-credits": "Purchase credits",
    "alert.purchasing-credits": "Purchasing Credits",
    "alert.purchased-credits": "Purchased Credits",
    "error.invalid-room": "Please select a room that belongs to this event",
    "error.invalid-date": "Please select a date from the event dates",
    "heading.your-transactions": "Your transactions (1 bonus credit on signup)",
    "event.add-room-heading": "Add Rooms to Event",
    "heading.credits-available": "Credits Available",
    "event.rooms-in-event": "Rooms assigned to event",
    "event.rooms-not-in-event": "Other Rooms in your account",
    "event.adding-room": "Adding Room to Event",
    "form.select-associations": "Associations that can manage their presentations",
    "form.select.room": "Select a room",
    "input.room.order": "Order",
    "heading.credits-required": "Credits required",
    "heading.credits-to-be-purchased": "Credits to be purchased",
    "message.create-event-credits-to-be-purchased": "You will be prompted to purchase credits when you click on 'Create Event'.",
    "message.create-event-credits-present": "You have enough credits, click 'Create Event' to create the event.",
    "message.add-credit-card-prompt": "Please add a credit card to your account if you wish to purchase more credits.",
    "input.event.audience_site_password": "Event Site Password",
    "input.event.schedule_background_color": "Schedule Background Color",
    "input.event.schedule_text_color": "Schedule Text Color",
    "error.room-has-presentations": "Cannot delete room when it has presentations in this event.",
    "button.add-room-to-event": "Add Room To Event",
    "button.delete-room-from-event": "Remove Room From Event",
    "input.presentation.pdfConvert": "PDF Convert",
    "label.agree-pdfConvert": "I agree that my presentation will be displayed as PDF on the website",
    "input.presentation.publicVideo": "Public Video",
    "input.presentation.skip": "Skip Seconds",
    "label.pptSize": "File Size",
    "label.pptVersion": "File Version",
    "heading.manage-participants": "Manage Participants",
    "table.transactions.date": "Date",
    "table.transactions.type": "Type",
    "table.transactions.credits": "Credits",
    "table.transactions.amount": "Amount",
    "table.transactions.invoice": "Invoice",
    "input.event.show_forum": "Show Forum",
    "input.event.show_quiz": "Show Quiz",
    "action.delete-presentation": "delete the presentation",
    "action.delete-video": "delete the video for",
    "input.emailContent": "Email Content",
    "forgot.password": "Forgot Password",
    "have.account": "Already have an account?",
    "new.register": "New Registration",
    "user.welcome": "Welcome",
    "user.creds": "Credit",
    "add.edit.event": "Add / Edit Event",
    "add.edit.room": "Add / Edit Room",
    "add.edit.speaker": "Add / Edit Speaker",
    "add.visio": "Activate Visio",
    "add.room": "Add Room",
    "text.event-slug": "Event Slug",
    "create.event.form": "Create Event",
    "event.form.name": "Event Name",
    "input.description": "Description",
    "create.speaker.form": 'Add Speaker',
    "nav.events": "Events",
    "nav.rooms": "Conference Rooms",
    "nav.speakers": "Speakers",
    "nav.options": "Options",
    "nav.themes": "Themes",
    "nav.types": "Types",
    "nav.associations": "Associations",
    "nav.credits": "Credits",
    "nav.legal": "Terms",
    "edit-new": 'Edit',
    "input.color.color": "Color",
    "button.save" : "Save",
    "form.saved": "Form Saved",
    "tooltip.event": "Events",
    "tooltip.room": "Rooms",
    "tooltip.speakers": "Speakers",
    "tooltip.contact": "Contact",
    "advanced.settings": "Advanced Settings",
    "label.uploadPhoto": "Upload Photo",
    "label.photoUploaded": "Photo Uploaded",
    "tooltip.download.latest":"Download latest presentation",
    "advanced.program": "Program",
    "add.credits": "Add Credits",
    "no.credits": "Number of credits",
    "proceed.payment": "Proceed to Payment",
    "is": "is",
    "heading.simulator": "simulator",
    "no.rooms": "Number of Rooms",
    "no.days": "Number of days",
    "additional.boradcast.years": "Additional broadcast years",
    "enable.pdf.download": "Enable download in PDF format",
    "disable.pdf.download": "Disable download in PDF format",
    "show.video": "Show Video",
    "hide.video": "Hide Video",
    "show.presentation": "Show Presentation",
    "hide.presentation": "Hide Presentation",
    "yes": 'Yes',
    "no": 'No',
    "email.heading.one": "Contact the speakers",
    "email.heading.two": "so that they can load the presentation file",
    "email.speakers.select": "Select",
    "email.speakers.select2": "Recipients",
    "form.select-speakers-without-video": "Speakers without video",
    "load.email": "Load Email",
    "view.history": "View History",
    "common.sort": "Sort",
    "from": "from",
    "to": "to",
    "accept.charge": "I accept that I will be charged",
    "input.room.streamingUrl": 'Streaming URL',
    "input.room.streamingPlaybackUrl": 'Streaming PlaybackUrl',
    "input.room.streamingWebcamUrl": 'Streaming Webcam URL',
    "input.room.streamingWebcamPlaybackUrl": 'Streaming Webcam PlaybackUrl',
    "input.room.streamingLogin": 'Streaming Login',
    "input.room.streamingPassword": 'Streaming Password',
    "done": "Done",
    "change": "Change",
    "accept.terms": "Must accept Terms and Conditions",
    "form.email.virtual": "Load virtual event email",
    "error.event-has-presentations": "Before deleting this event, please delete all the presentations.",
    "error.chargeable-action": "That action will cost you, please confirm by selecting the checkbox",
    "eslides.fields": "Only for e-slides",
    "required.field": 'Required',
    "input.audience.name": "Name",
    "input.audience.email": "Email",
    "input.audience.moderator": "Moderator",
    "input.audience.blocked": "Desactivated",
    "input.audience.unblocked": "Activated",
    "button.export-participants": "Export CSV",
    "button.invite-participant": "Invite",
    "button.download-import-template": "Download Template",
    "button.import-participants": "Import CSV",
    "button.submit": "Submit",
    "common.presentations.text": "Presentations",
    "common.videos.text": "Videos",
    "access.moderator.site": "To access the moderator site",
    "download.app.text": "Don't forget to download the application",
    "site.moderator": "site moderator",
    "site.audience": "Event site",
    "deadline.text": "deadline by which speakers can no longer upload their presentation",
    "rich.text": "Rich Text",
    "purchase.text": "Purchase",
    "for.text": "for",
    "link-credit-card": "Link/Update Credit Card",
    "loaded.files": "Loaded Files",
    "recorded.videos": "Recorded Videos",
    "loded.videos": "Loaded videos",
    "select": "Select",
    "show.sent.emails": "Show Sent Emails",
    "email.sent": "Emails Sent",
    "add.logo": "Add a logo",
    "email.fetch.wait": "Please wait while we fetch the emails that were sent",
    "search.email": "Search by email or name",
    "no.sent.emails" : "No emails have been sent for this event.",
    "message.please-wait": "Please wait...",
    "copied.text": "Copied!",
    "show.public.video.views": "Show the total number of views on public video pages",
    "select.login.and.password": "Login and Password",
    "authenticationMode.global": "Creation of accounts",
    "authenticationMode.whitelist": "User list (with Excel or CSV file)",
    "total.presentations.created": "presentation(s) created",
    "total.video.views": "Total Number of views",
    "views": "views",
    "action.delete-association": "delete the association",
    "action.delete-session": "delete the session",
    "action.delete-theme": "delete the theme",
    "action.delete-type": "delete the type",
    "drop-click-csv": "Drop CSV file here or click to upload.",

    "error.items-to-be-created": "The following items need to be created to import the CSV",

    "export.presentation-list": "Export list of presentations",
    "import.presentation-list": "Import list of presentations",
    "button.delete-presentations-without-ppt": "Delete all presentations without a file",

    "input.presentation.liveStreaming": "Live streaming",
    "username.header": "Username",
    "participants.list": "Participants list",
    "p.moderator": 'Moderator',
    "p.user": 'User',
    "unlocked": 'Unlocked',
    "locked": 'Locked',
    "button.upload-video": "Upload Video",
    "processing.csv": 'Processing CSV, please wait',
    "event.updating": "Updating Event",
    "presentation.updating": "Updating Presentation",
    "room.updating": "Updating Room",
    "speaker.updating": "Updating Speaker",
    "input.externalPdfLink": "Or external PDF Link",
    "block.access.presentation.with.password": "Block the access to the presentations by a password",
    "allow.creating.account": "Allow access by creating an account",
    "allow.validate.accounts": "Automatically validate created accounts",
    "allow.anonymous.access": "Allow access to presentations to users without account",
    "header.source": "Source",
    "header.photo": "Photo",
    "header.login": "Login",
    "edit.participant": "Edit Participant List",
    "add.participant": "Add Participant List",
    "input.photo": "Photo",
    "input.state.locked": "Locked?",
    "input.audience.disabled": "Disabled",
    "error.login-taken": "This login is already taken",
    "error.email-taken": "This email is already in use",
    "message.user-created": "User has been created",
    "message.user-updated": "User has been updated",
    "message.checking.login-and-email": "Checking Login and Email",
    "message.creating.user": "Creating User",
    "message.updating.user": "Updating User",
    "user-list-add.success": "User added Successfully",
    "user-list-email.in.use": "This email address is already in use.",
    "email.participants": 'Email Participants',
    "email.error": 'Error Sending Email',
    "delete.participants": 'Delete Selected Participants?',
    "input.password-new": "Enter new password (optional)",
    "input.to": 'To',
    "input.subject": 'Subject',
    "button.add": 'Add',
    "tooltip.delete-attendees": 'Delete selected attendees',
    "tooltip.email-attendees": 'Email selected attendees',
    "authorize.assosication.login": "Authorize associations to manage and moderate their presentations",
    "authorize.speaker.login": "Authorize speakers to moderate their presentations",
    "connection.externalURL": "Connection to external website",
    "table.header.state": "State",

    "state.activated":"Activated",
    "state.desactivated":"Desactivated",
    "moderator.activated":"Moderator",
    "moderator.desactivated":"Attendee",
    "speaker.activated":"Speaker",
    "speaker.desactivated":" Non Speaker",
    "association.activated":"Association",
    "association.desactivated":"Not an Association",
  }
}

export default en;
